import { makeRequest } from '../utils/apiUtils';
import cookie from 'cookie';

import config from 'cityads-v3/config';

export const SUBMIT_REGISTER_ADVERTISER_FORM = "auth/SUBMIT_REGISTER_ADVERTISER_FORM";
export const SUBMIT_REGISTER_ADVERTISER_FORM_SUCCESS = "auth/SUBMIT_REGISTER_ADVERTISER_FORM_SUCCESS";
export const SUBMIT_REGISTER_ADVERTISER_FORM_FAIL = "auth/SUBMIT_REGISTER_ADVERTISER_FORM_FAIL";

export const CHECK_AUTH = "auth/CHECK_AUTH";
export const CHECK_AUTH_SUCCESS = "auth/CHECK_AUTH_SUCCESS";
export const CHECK_AUTH_FAIL = "auth/CHECK_AUTH_FAIL";
export const CHECK_AUTH_ABORTED = "auth/CHECK_AUTH_ABORTED";

export const REQUEST_STORAGE_COOKIE = "auth/REQUEST_STORAGE_COOKIE";
export const REQUEST_STORAGE_COOKIE_SUCCESS = "auth/REQUEST_STORAGE_COOKIE_SUCCESS";
export const REQUEST_STORAGE_COOKIE_FAIL = "auth/REQUEST_STORAGE_COOKIE_FAIL";

export const SET_REFERRAL = "auth/SET_REFERRAL";
export const SET_REFERRAL_SUCCESS = "auth/SET_REFERRAL_SUCCESS";
export const SET_REFERRAL_FAIL = "auth/SET_REFERRAL_FAIL";

export const LOAD_USER_BALANCE = "auth/LOAD_USER_BALANCE";
export const LOAD_USER_BALANCE_SUCCESS = "auth/LOAD_USER_BALANCE_SUCCESS";
export const LOAD_USER_BALANCE_FAIL = "auth/LOAD_USER_BALANCE_FAIL";

export const SET_CLICK_ID = "auth/SET_CLICK_ID";
export const SET_CLICK_ID_SUCCESS = "auth/SET_CLICK_ID_SUCCESS";
export const SET_CLICK_ID_FAIL = "auth/SET_CLICK_ID_FAIL";

export const SET_NEED_SADUKA_AUTH_UPDATE = "auth/SET_NEED_SADUKA_AUTH_UPDATE";
export const SET_API_HEADERS = "auth/SET_API_HEADERS";

export const AUTH_STORAGE_COOKIE_NAME = config.AUTH_STORAGE_COOKIE_NAME;

export function submitRegisterAdvertiserForm(params) {
  const body = new FormData();

  body.append('type', 'advertiser');
  Object.keys(params).forEach(item => {
    body.append(item, params[item]);
  });

  body.append('register_advertiser', 'advertiser');

  return makeRequest('/saduka/adv_registration', {
    types: [SUBMIT_REGISTER_ADVERTISER_FORM, SUBMIT_REGISTER_ADVERTISER_FORM_SUCCESS, SUBMIT_REGISTER_ADVERTISER_FORM_FAIL],
    options: {
      method: 'POST',
      body
    }
  });
}

export function checkAuth({ cookies = {} } = {}) {
  const Cookie = Object.keys(cookies.cookies || {}).map(key => cookie.serialize(key, cookies.cookies[key])).join('; ');
  return makeRequest(config.AUTH_URL + '/action/check', {
    types: [CHECK_AUTH, CHECK_AUTH_SUCCESS, CHECK_AUTH_FAIL],
    options: {
      credentials: 'include',
      headers: {
        Cookie
      }
    }
  });
}

export function checkStorageCookie({ cookies = { cookies: {}} } = {}) {
  const Cookie = Object.keys(cookies.cookies || {}).map(key => cookie.serialize(key, cookies.cookies[key])).join('; ');
  return makeRequest('/saduka/auth/update', {
    types: [REQUEST_STORAGE_COOKIE, REQUEST_STORAGE_COOKIE_SUCCESS, REQUEST_STORAGE_COOKIE_FAIL],
    options: {
      credentials: 'include',
      headers: {
        Cookie
      }
    }
  });
}

export function checkAuthFull({ cookies = null } = {}) {
  return dispatch => {
    return checkAuth({ cookies })(dispatch)
      .then((res) => {
        if (res) {
          return checkStorageCookie()(dispatch);
        }
      })
    ;
  }
}

export function setReferral(uid) {
  return makeRequest(config.AUTH_URL + '/action/referral/' + uid, {
    types: [SET_REFERRAL, SET_REFERRAL_SUCCESS, SET_REFERRAL_FAIL],
    options: {
      credentials: 'include',
    },
    apiOptions: {
      toJson: false
    },
    uid
  });
}

export function loadUserBalance(url) {
  return makeRequest(url, {
    types: [LOAD_USER_BALANCE, LOAD_USER_BALANCE_SUCCESS, LOAD_USER_BALANCE_FAIL],
    options: {
      credentials: 'include'
    }
  })
}

export function setClickId(referral, clickId, enot) {
  return makeRequest(`${config.AUTH_URL}/action/referral_click/${referral}/${clickId}?encrypt_uid=${enot==='barsuk' ? 0 : 1}`, {
    types: [SET_CLICK_ID, SET_CLICK_ID_SUCCESS, SET_CLICK_ID_FAIL],
    options: {
      credentials: 'include',
    },
    apiOptions: {
      toJson: false
    },
    referral,
    clickId,
    enot
  });
}
